/**
 * Fragment de routes du paquet v7-p05-gouvernance-ecrans (vague V7, règle R2 du découpage V4–V11 : un fragment par
 * paquet). Composants chargés à la demande (règle de chargement du registre).
 * Routes du socle remplacées (YAML `couvre: route:`) : `/programme/gouvernance` → programme-gouvernance,
 * `/programme/capacite` → programme-capacite, `/programme/roadmap` → programme-roadmap, `/programme/rapport` →
 * programme-suivi. Routes neuves : portes et fiche d'instance sous `/programme/gouvernance/`, journal d'audit du
 * programme et fiche d'un événement sous `/programme/journal-audit`. Programme transmis par `?programme=`.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProgrammeGouvernance = lazy(() => import('../ecrans/v7/gouvernance/ProgrammeGouvernance'))
const ProgrammePortes = lazy(() => import('../ecrans/v7/gouvernance/ProgrammePortes'))
const ProgrammeArcInstanceFiche = lazy(() => import('../ecrans/v7/gouvernance/ProgrammeArcInstanceFiche'))
const ProgrammeJournalAudit = lazy(() => import('../ecrans/v7/gouvernance/ProgrammeJournalAudit'))
const ProgrammeEvenementAuditFiche = lazy(() => import('../ecrans/v7/gouvernance/ProgrammeEvenementAuditFiche'))
const ProgrammeCapacite = lazy(() => import('../ecrans/v7/gouvernance/ProgrammeCapacite'))
const ProgrammeRoadmap = lazy(() => import('../ecrans/v7/gouvernance/ProgrammeRoadmap'))
const ProgrammeSuivi = lazy(() => import('../ecrans/v7/gouvernance/ProgrammeSuivi'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v7-gouvernance',
  routes: [
    { chemin: '/programme/gouvernance', element: ecran(ProgrammeGouvernance), remplace: true },
    { chemin: '/programme/capacite', element: ecran(ProgrammeCapacite), remplace: true },
    { chemin: '/programme/roadmap', element: ecran(ProgrammeRoadmap), remplace: true },
    { chemin: '/programme/rapport', element: ecran(ProgrammeSuivi), remplace: true },
    { chemin: '/programme/gouvernance/portes', element: ecran(ProgrammePortes) },
    { chemin: '/programme/gouvernance/instances/:instanceId', element: ecran(ProgrammeArcInstanceFiche) },
    { chemin: '/programme/journal-audit', element: ecran(ProgrammeJournalAudit) },
    { chemin: '/programme/journal-audit/evenements/:evenementId', element: ecran(ProgrammeEvenementAuditFiche) },
  ],
}
